import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Delete as DeleteIcon } from '@mui/icons-material';
import LOOKUP from 'constants/lookup';
import { getCampaigns, deleteCampaign } from 'actions/EntityActions';
import { getCsvReport } from 'actions/ReportsAction';
import { campaignListCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import Pagination from 'screens/components/basic/Pagination';
import Button from 'screens/components/basic/Button';
import DialogHeader from "screens/components/basic/DialogHeader";
import CardSimple from 'screens/components/basic/CardSimple';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
// Advanced Components
import DialogInput from "screens/components/advanced/DialogInput";
import GenericTable from 'screens/components/advanced/GenericTable';
import ToggleInput from 'screens/components/basic/ToggleInput';

class CampaignList extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      activePage: 1,
      dialogExportCSV: false,
      itemsPerPage: 25
    };
  }

  componentWillMount = () => {
    this.search();
  }

  search = () => {
    this.props.getCampaigns({
      branchId: this.props.branchId,
      page: this.state.activePage,
      itemsPerPage: this.state.itemsPerPage
    });
  }

  downloadReport = () => {
    let isActive = this.props.IncludeInactiveCampaign != undefined & this.props.IncludeInactiveCampaign == true ? 0 : 1;
    let branchId = this.props.branchId;
    this.props.getCsvReport(`reports/excel/campainList?branchId=${branchId}&isActive=${isActive}`, "campaignList");
  }

  changePage = (e) => {
    this.setState({ activePage: e }, this.search);
  }

  redirectToAddPage = () => {
    this.props.navigate("/manage/campaign/add");
  }

  redirectToEditPage = (id) => {
    this.props.navigate(`/manage/campaign/edit/${id}`);
  }

  openExportCSVDialog = () => {
    this.setState({ dialogExportCSV: true });
  }

  closeExportCSVDialog = () => {
    this.setState({ dialogExportCSV: false });
  }

  openDialog = (itemId) => {
    this.setState({ dialog: true, itemId: itemId });
  };

  closeDialog = () => {
    this.setState({ dialog: false });
  };

  confirmDeleteCampaign = (itemID) => {
    this.props.deleteCampaign(itemID, this.props.branchId);
    this.closeDialog();
  };

  render() {
    const p = this.props;
    const s = this.state;

    const tableRows = p.campaigns.map(item => {
      return {
        Name: (<Link className="edit-link" to={`/manage/campaign/edit/${item.id}`}>{item.name}</Link>),
        Period: item.period,
        Type: (item.typeText == 'One Time Sale' ? 'One Time' : 'Recurrent'),
        WeekDays: item.daysOfWeekToApplyText,
        Status: (item.statusText !== "Active" ? <p className="statusIconRed m-0">{item.statusText}</p> :
          <p className="statusIconGreen m-0">{item.statusText}</p>),
        Discount: item.discountType == 3 ? "Multi" : item.discountText,
        EditIcons: (
          <Button
            type="IconEditButton"
            mini={true}
            onTouchTap={() => this.redirectToEditPage(item.id)}
          />
        ),
        DeleteIcons: (
          <Button
            mini={true}
            type="IconButton"
            className="glyphicon glyphicon-remove-circle"
            onTouchTap={() => this.openDialog(item.id)}
            icon={<DeleteIcon />}
          />
        )
      };
    });

    return (
      <Grid headerContent={campaignListCrumb}>
        <section className="page-top">
          <div className="page-top-container mb-0">
            <div className="page-title">
              <h2>{LOOKUP.menu.manage.items.campaign.text}</h2>
            </div>
            <div className="page-buttons">
              <Button
                type="AddButton"
                mini={true}
                className="bg-light-green"
                label={LOOKUP.campaign.controls.addNewButton}
                onTouchTap={() => this.redirectToAddPage()}
              />
              <Button
                type="AddButton"
                mini={true}
                className="bg-light-green ml-2"
                label={LOOKUP.campaign.controls.exportCSV}
                onTouchTap={() => this.openExportCSVDialog()} />
            </div>
          </div>
        </section>
        <section>
          <CardSimple>
            <GenericTable
              multiSelectable={false}
              enableSelectAll={false}
              selectable={false}
              columns={LOOKUP.campaign.tableColumns}
              rows={tableRows}
              stripedRows={true}
            />
            <Pagination
              length={p.totalCampaigns || 0}
              itemsPerPage={s.itemsPerPage}
              activePage={s.activePage}
              onPageChange={this.changePage}
            />
          </CardSimple>
        </section>
        {/* MODAL DIALOG */}
        <DialogInput
          title={
            <div className="modal-title p-0">
              <DialogHeader
                text="Export CSV"
                classicClass="posDialogClassic"
              />
            </div>
          }
          modal={true}
          autoScrollBodyContent={true}
          style={{ zIndex: '980' }}
          actions={(
            <Button
              name="buttonClose"
              label="Close"
              primary={false}
              className="btnCleanSearch btnCloseCarousels"
              onTouchTap={() => this.closeExportCSVDialog()}
            />
          )}
          contentStyle={{ width: '95%', maxWidth: 'none' }}
          open={this.state.dialogExportCSV}>
          <div>
            <div className="row">
              <div className="col-lg-12">
                <div className="col-lg-4 mt-2">
                  <h3 className="mt-2 purpleText">Export CSV</h3>
                </div>
                <br />
                <div className="col-lg-4 inline-checkbox-btns">
                  <ToggleInput
                    className="legalBarcode btnToggleLabel"
                    name="IncludeInactiveCampaign"
                    label={LOOKUP.campaign.controls.toggleExportCSV} />
                </div>
              </div>
            </div>
            <div className="row">
              <Button
                className="pull-right"
                name="buttonAddItem"
                label="Export CSV"
                primary={true}
                onTouchTap={() => this.downloadReport()} />
            </div>
          </div>
        </DialogInput>
        <DialogInput
          title={
            <div className="modal-title noPadding mb-2">
              <DialogHeader
                text="CONFIRM DELETE"
                classicClass="posDialogClassic"
              />
            </div>
          }
          modal={true}
          open={this.state.dialog}
          autoScrollBodyContent={true}
          style={{ zIndex: "950" }}
          actions={[
            <Button
              key={1}
              name="CancelButton"
              label="Cancel"
              primary={true}
              className="btn-space-20"
              onTouchTap={() => this.closeDialog()}
            />,
            <Button
              key={2}
              name="ConfirmDelete"
              label="Delete"
              primary={true}
              className="btn-space-20"
              onTouchTap={() => this.confirmDeleteCampaign(this.state.itemId)}
            />]}
          contentStyle={{ width: "65%" }}>
          <div>
            <div className="row">
              <div className="col-lg-12">
                <h4 className="purpleText">
                  Are you sure you wish to delete this campaign?
                </h4>
              </div>
            </div>
          </div>
        </DialogInput>
      </Grid>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    campaigns: state.entity.campaignList || [],
    totalCampaigns: state.entity.campaignListLength || 0,
    branchId: state.common.branchId,
    IncludeInactiveCampaign: state.form["IncludeInactiveCampaign"]
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getCampaigns: (model) => dispatch(getCampaigns(model)),
    deleteCampaign: (id, branchId) => dispatch(deleteCampaign(id, branchId)),
    getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(CampaignList));
